import { backgroundColor } from "../const";
import { Left } from "./left";
import { Middle } from "./middle";
import { Right } from "./right";
import { MuiAppBar, MuiToolbar } from "@dealer-center/core-components";

export const TopBar = () => {
  return (
    <MuiAppBar position="sticky" sx={{ backgroundColor }}>
      <MuiToolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          "&>div": {
            width: "100%"
          }
        }}
      >
        <Left />
        <Middle />
        <Right />
      </MuiToolbar>
    </MuiAppBar>
  );
};
